export const tokens = {
  TEXT_XXL_BOLD: 'text-xxl-bold',
  TEXT_XXL_EXTRABOLD: 'text-xxl-extrabold',
  TEXT_XXL_REGULAR: 'text-xxl-regular',
  TEXT_XL_BOLD: 'text-xl-bold',
  TEXT_XL_EXTRABOLD: 'text-xl-extrabold',
  TEXT_XL_REGULAR: 'text-xl-regular',
  TEXT_LG_BOLD: 'text-lg-bold',
  TEXT_LG_EXTRABOLD: 'text-lg-extrabold',
  TEXT_LG_REGULAR: 'text-lg-regular',
  TEXT_MD_BOLD: 'text-md-bold',
  TEXT_MD_EXTRABOLD: 'text-md-extrabold',
  TEXT_MD_REGULAR: 'text-md-regular',
  TEXT_SM_BOLD: 'text-sm-bold',
  TEXT_SM_EXTRABOLD: 'text-sm-extrabold',
  TEXT_SM_REGULAR: 'text-sm-regular',
  TEXT_XS_BOLD: 'text-xs-bold',
  TEXT_XS_EXTRABOLD: 'text-xs-extrabold',
  TEXT_XS_REGULAR: 'text-xs-regular'
};
export default tokens;